import { useSelector } from 'react-redux';
import { specificationsSelector } from '../../selectors/newbuilding';
import { SpecificationColumn, SpecificationItem, Specifications } from '../../components/Specifications';

export const SpecificationsContainer = () => {
  const specifications = useSelector(specificationsSelector);
  const specLen = specifications.length;
  const specMid = Math.ceil(specLen / 2);
  const specificationsColumns = [specifications.slice(0, specMid), specifications.slice(specMid, specLen)];

  return (
    <Specifications>
      <SpecificationColumn>
        {specificationsColumns[0].map(item => {
          return <SpecificationItem key={item.title} title={item.title} value={item.value || '-'} />;
        })}
      </SpecificationColumn>
      <SpecificationColumn>
        {specificationsColumns[1].map(item => {
          return <SpecificationItem key={item.title} title={item.title} value={item.value || '-'} />;
        })}
      </SpecificationColumn>
    </Specifications>
  );
};
